// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import UnsubscribePage, { getStaticProps as getProps } from 'pages/unsub';

export default UnsubscribePage;
export const getStaticProps = getProps;
